import { cn } from "@/lib/utils";

interface DatelineItem {
  label: string;
  value: React.ReactNode;
  tone?: "critical" | "important";
}

interface DatelineProps {
  items: DatelineItem[];
}

export function Dateline({ items }: DatelineProps) {
  if (items.length === 0) return null;
  return (
    <dl className="flex flex-wrap items-baseline gap-x-4 gap-y-1.5 border-y border-border/60 py-3 text-sm">
      {items.map((item, i) => (
        <div key={item.label} className="inline-flex items-baseline gap-2">
          {i > 0 && (
            <span
              className="hidden sm:inline text-muted-foreground select-none mr-2"
              aria-hidden="true"
            >
              /
            </span>
          )}
          <dt className="text-xs font-medium text-muted-foreground">
            {item.label}
          </dt>
          <dd
            className={cn(
              "tabular-nums text-foreground",
              item.tone === "critical" && "text-severity-critical",
              item.tone === "important" && "text-severity-important",
            )}
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
